import IndirizzoEntity from '../generale/IndirizzoEntity';
import UtenteEntity from '../associati/UtenteEntity';

export default function (associazione) {
  this.id = associazione ? associazione.id : null;
  this.Denominazione = associazione ? associazione.Denominazione : null;
  this.CodiceFiscale = associazione ? associazione.CodiceFiscale : null;
  this.PartitaIVA = associazione ? associazione.PartitaIVA : null;
  this.isAttivo = associazione ? associazione.isAttivo : true;
  this.Tipo = associazione ? associazione.Tipo : 'A';
  this.Telefono = associazione ? associazione.Telefono : null;
  this.Cellulare = associazione ? associazione.Cellulare : null;
  this.Email = associazione ? associazione.Email : null;
  this.EmailPec = associazione ? associazione.EmailPec : null;
  this.EmailResponsabile = associazione ? associazione.EmailResponsabile : null;
  this.SitoWeb = associazione ? associazione.SitoWeb : null;
  this.IndirizzoCorrispondenza = associazione ? new IndirizzoEntity(associazione.IndirizzoCorrispondenza) : new IndirizzoEntity();
  this.IndirizzoDomicilio = associazione ? (associazione.IndirizzoDomicilio ? new IndirizzoEntity(associazione.IndirizzoDomicilio) : null) : null;
  this.IndirizzoCampo = associazione ? (associazione.IndirizzoCampo ? new IndirizzoEntity(associazione.IndirizzoCampo) : null) : null;
  this.isTrattamentoDatiPersonali = associazione ? associazione.isTrattamentoDatiPersonali : false;
  this.DataTrattamentoDatiPersonali = associazione ? associazione.DataTrattamentoDatiPersonali : null;
  this.createdAt = associazione ? associazione.createdAt : null;
  this.updatedAt = associazione ? associazione.updatedAt : null;
  this.Note = associazione ? associazione.Note : null;
  this.canViewData = associazione ? associazione.canViewData : false;
  this.NotificaEmail = associazione ? associazione.NotificaEmail : false;

  this.Sezione = associazione ? new SezioneEntity(associazione.Sezione) : new SezioneEntity();
  this.Codice = associazione ? associazione.Codice : null;
  this.DataCostituzione = associazione ? associazione.DataCostituzione : null;
  this.DataIscrizione = associazione ? associazione.DataIscrizione : null;
  this.DataScadenza = associazione ? associazione.DataScadenza : null;
  this.AltreAssociazioni = associazione ? associazione.AltreAssociazioni : null;
  this.NumeroRepertorio = associazione ? associazione.NumeroRepertorio : null;
  this.Somministrazione = associazione ? associazione.Somministrazione : false;
  this.TipoSocieta = associazione ? associazione.TipoSocieta : null;
  this.TipoAssociazione = associazione ? associazione.TipoAssociazione : null;
  this.UfficioRegistro = associazione ? associazione.UfficioRegistro : null;
  this.NumeroPostiRiservati = associazione ? associazione.NumeroPostiRiservati : 0;
  this.IdSodalizio = associazione ? associazione.IdSodalizio : 0;
  this.Utente = associazione ? new UtenteEntity(associazione.Utente) : null;
}

function SezioneEntity (s) {
  this.id = s ? s.id : null;
  this.Codice = s ? s.Codice : null;
  this.Descrizione = s ? s.Descrizione : null;
  this.Tipo = s ? s.Tipo : null;
}